import { render, staticRenderFns } from "./IssueViewerConfig.vue?vue&type=template&id=0a9356da&"
import script from "./IssueViewerConfig.vue?vue&type=script&lang=ts&"
export * from "./IssueViewerConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports